import T from '../../Utils/Locale';
let partner = {};
export const setPartner = (newPartner) => {
    partner = newPartner;
};
export default (key, variables) => {
    if (partner.translations && key in partner.translations) {
        return partner.translations[key];
    }
    return T(key, variables);
};
